export default __webpack_public_path__ + "static/media/hair-9-1.1f7ff5ec.svg";